import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { DesignToken } from '../types';
import { getToken } from '../utils/getToken';
import { getSpacingToken, SpacingToken } from '../utils/getSpacingToken';

export const useGetToken = () => {
    const theme = useTheme();
    return useMemo(
        () => ({
            getToken: <T extends DesignToken>(tokenName: T) => getToken(tokenName)({ theme }),
            getSpacingToken: <S extends SpacingToken>(spacingToken: S) => getSpacingToken(spacingToken)({ theme }),
        }),
        [theme]
    );
};

export const useToken = <T extends DesignToken>(tokenName: T) => {
    const theme = useTheme();
    return getToken(tokenName)({ theme });
};
